const locale = {
  SIGN_UP_TITLE: 'Регистрация',
  SIGN_UP_SUBTITLE: 'Създайте профил',
  SIGN_UP_BUTTON: 'Регистрация',
  SIGNING_UP: 'Регистриране...',
  HAVE_ACCOUNT: 'Вече имате профил?',
  SIGN_IN_LINK: 'Влезте тук',
  
  // Step labels
  STEP_PERSONAL_INFO: 'Лична информация',
  STEP_HOTEL_INFO: 'Информация за хотела',
  
  // Navigation
  BACK: 'Назад',
  NEXT: 'Напред',
  
  // Personal Info fields
  FIRST_NAME_LABEL: 'Име',
  LAST_NAME_LABEL: 'Фамилия',
  USERNAME_LABEL: 'Потребителско име',
  
  // Hotel Info fields
  HOTEL_NAME_LABEL: 'Име на хотела',
  HOTEL_DOMAIN_LABEL: 'Домейн на хотела',
  
  // Account Info fields
  EMAIL_LABEL: 'Имейл адрес',
  PASSWORD_LABEL: 'Парола',
  CONFIRM_PASSWORD_LABEL: 'Потвърди парола',
  
  // Validation messages
  FIRST_NAME_REQUIRED: 'Името е задължително',
  FIRST_NAME_MIN_LENGTH: 'Името трябва да е поне 2 символа',
  LAST_NAME_REQUIRED: 'Фамилията е задължителна',
  LAST_NAME_MIN_LENGTH: 'Фамилията трябва да е поне 2 символа',
  USERNAME_REQUIRED: 'Потребителското име е задължително',
  USERNAME_MIN_LENGTH: 'Потребителското име трябва да е поне 3 символа',
  USERNAME_INVALID: 'Потребителското име може да съдържа само букви, цифри и долна черта',
  HOTEL_NAME_REQUIRED: 'Името на хотела е задължително',
  HOTEL_NAME_MIN_LENGTH: 'Името на хотела трябва да е поне 2 символа',
  HOTEL_DOMAIN_REQUIRED: 'Домейнът на хотела е задължителен',
  HOTEL_DOMAIN_INVALID: 'Моля, въведете валиден домейн (например, example.com)',
  EMAIL_REQUIRED: 'Имейл адресът е задължителен',
  EMAIL_INVALID: 'Моля, въведете валиден имейл адрес',
  PASSWORD_REQUIRED: 'Паролата е задължителна',
  PASSWORD_MIN_LENGTH: 'Паролата трябва да е поне 8 символа',
  CONFIRM_PASSWORD_REQUIRED: 'Моля, потвърдете паролата си',
  PASSWORDS_DONT_MATCH: 'Паролите не съвпадат',
  
  // Password strength
  PASSWORD_STRENGTH_LABEL: 'Сила на паролата:',
  PASSWORD_STRENGTH_WEAK: 'Слаба',
  PASSWORD_STRENGTH_FAIR: 'Средна',
  PASSWORD_STRENGTH_GOOD: 'Добра',
  PASSWORD_STRENGTH_STRONG: 'Силна',
  
  // Password requirements
  PASSWORD_REQUIREMENTS_TITLE: 'Изисквания за паролата:',
  PASSWORD_REQUIREMENT_LENGTH: 'Поне 8 символа',
  PASSWORD_REQUIREMENT_UPPERCASE: 'Поне 1 главна буква',
  PASSWORD_REQUIREMENT_LOWERCASE: 'Поне 1 малка буква',
  PASSWORD_REQUIREMENT_NUMBER: 'Поне 1 цифра',
  PASSWORD_REQUIREMENT_SPECIAL: 'Поне 1 специален символ',
  PASSWORD_REQUIREMENT_LATIN: 'Само латински символи',
  PASSWORD_REQUIREMENT_SECURE: 'Преминава анализ на сигурността',
  PASSWORD_REQUIREMENT_NOT_COMMON: 'Не е често използвана парола',
  PASSWORD_IS_SECURE: 'Паролата отговаря на стандартите за сигурност',
  PASSWORD_NEEDS_IMPROVEMENT: 'Паролата се нуждае от подобрение',
  PASSWORD_BASIC_REQUIREMENTS: 'Трябва да съдържа: главни, малки букви, цифра, спец. символ, 8+ символа, само латински букви',
  PASSWORD_ANALYZING: 'Анализиране на сигурността на паролата...',
  
  // Password tips
  PASSWORD_TIPS_TITLE: 'Съвети за силна парола:',
  PASSWORD_TIPS_HELP: 'Нужна помощ?',
  PASSWORD_TIP_GENERATE: '• Използвайте бутона за генериране на сигурна парола',
  PASSWORD_TIP_AVOID_COMMON: '• Избягвайте общи думи и предсказуеми модели',
  PASSWORD_TIP_MIX_CHARS: '• Комбинирайте главни, малки букви, цифри и символи',
  PASSWORD_TIP_UNIQUE: '• Направете я уникална - не повтаряйте пароли',
  
  // Error messages
  INVALID_SIGNUP_DATA: 'Невалидни данни за регистрация',
  EMAIL_ALREADY_EXISTS: 'Вече съществува профил с този имейл',
  USERNAME_ALREADY_EXISTS: 'Това потребителско име вече е заето',
  HOTEL_NAME_ALREADY_EXISTS: 'Вече съществува хотел с това име',
  HOTEL_DOMAIN_ALREADY_EXISTS: 'Този домейн вече се използва от друг хотел',
  PASSWORD_TOO_WEAK: 'Паролата е твърде слаба. Използвайте по-силна парола',
  PASSWORD_TOO_COMMON: 'Паролата се използва твърде често. Моля, изберете нещо по-сигурно.',
  GENERATE_PASSWORD: 'Генерирай сигурна парола',
  PASSWORD_GENERATED: 'Паролата е генерирана успешно',
  
  // Enzoic feedback messages (these will be mapped from Enzoic feedback)
  ENZOIC_FEEDBACK_TITLE: 'Анализ на сигурността на паролата:',
  ENZOIC_WEAKNESS_DICTIONARY: 'Тази парола се среща в списъци с често използвани пароли',
  ENZOIC_WEAKNESS_PREDICTABLE: 'Тази парола следва предсказуеми модели',
  ENZOIC_WEAKNESS_REPETITIVE: 'Тази парола съдържа повтарящи се символи',
  ENZOIC_WEAKNESS_SEQUENCE: 'Тази парола съдържа последователни символи',
  ENZOIC_WEAKNESS_KEYBOARD: 'Тази парола следва модели от клавиатурата',
  ENZOIC_WEAKNESS_DATE: 'Тази парола съдържа дати',
  ENZOIC_WEAKNESS_PERSONAL: 'Тази парола може да съдържа лична информация',
  ENZOIC_WEAKNESS_COMPROMISED: 'Тази парола е намерена в нарушения на данни',
  ACCOUNT_DISABLED: 'Вашият профил е деактивиран. Свържете се с поддръжката',
  ACCOUNT_LOCKED: 'Профилът е заключен. Свържете се с администратор',
  PASSWORD_SIGNUP_DISABLED: 'Регистрацията с парола е временно деактивирана. Моля, използвайте алтернативни методи',
  ORG_CREATION_FAILED: 'Неуспешно създаване на хотелска организация. Моля, опитайте отново',
  
  // Network and API errors
  NETWORK_ERROR: 'Грешка в мрежата. Моля, проверете връзката си',
  CONNECTION_TIMEOUT: 'Изтичане на връзката. Моля, проверете интернет връзката си',
  SERVER_ERROR: 'Грешка в сървъра. Моля, опитайте отново по-късно',
  SERVICE_UNAVAILABLE: 'Услугата за удостоверяване е временно недостъпна',
  BAD_REQUEST: 'Невалидна заявка. Моля, проверете въведените данни',
  UNKNOWN_ERROR: 'Възникна грешка. Моля, опитайте отново',
};

export default locale; 